/* Optional native-picker guard. No effect on products without the setting. */
document.querySelectorAll('variant-selects[data-required-option]').forEach((picker) => {
  if (picker.dataset.requiredChoiceBound) return;
  picker.dataset.requiredChoiceBound = 'true';
  const groups = [...picker.querySelectorAll('.product-form__input')];
  const required = groups[Number(picker.dataset.requiredOption) - 1];
  if (!required || !required.querySelector('input[type="radio"]')) return;
  const missing = () => !required.querySelector('input[type="radio"]:checked');
  const section = picker.closest('section');
  const button = section.querySelector('button[name="add"]');
  const hold = () => {
    if (!missing() || !button) return;
    button.disabled = true;
    const label = button.querySelector('.main-atc__label__line-1 > span');
    if (label) label.textContent = picker.dataset.requiredPrompt;
  };
  hold();
  section.addEventListener('submit', (event) => {
    if (!missing()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    required.querySelector('input[type="radio"]')?.focus();
  }, true);
  picker.addEventListener('change', (event) => {
    if (!missing()) return; // Once complete, native Shrine handles price, ID and availability.
    event.stopImmediatePropagation(); // Native updateOptions requires a checked value in every group.
    hold();
    const choices = groups.map(g => g.querySelector('input[type="radio"]:checked, select')?.value);
    const variants = JSON.parse(picker.querySelector('script[type="application/json"]').textContent);
    const variant = variants.find(v => v.options.every((value, i) => !choices[i] || choices[i] === value));
    if (!variant) return;
    const changedIndex = groups.indexOf(event.target.closest('.product-form__input'));
    const label = document.getElementById(`custom-label-${picker.dataset.section}-${changedIndex + 1}`);
    if (label) label.textContent = `${event.target.name} : ${event.target.value}`;
    section.querySelectorAll('media-gallery').forEach(gallery => {
      if (variant.featured_media && gallery.setActiveMedia) {
        gallery.setActiveMedia(`${picker.dataset.section}-${variant.featured_media.id}`, false, picker.dataset.hasFiltering === 'true', variant);
      }
    });
  }, true);
});
